import { Flex, Header, Icon, IconButton, InlineInput } from '@driftt/dds'
import { faCheck } from '@driftt/dds.icons/light/faCheck'
import { faPenToSquare } from '@driftt/dds.icons/light/faPenToSquare'
import { faXmark } from '@driftt/dds.icons/light/faXmark'
import React, { useState } from 'react'

const HeaderInlineInput = ({
  value = '',
  placeholder,
  disabled = false,
  onChange = () => {},
}: {
  value?: string
  placeholder?: string
  disabled?: boolean
  onChange?: (val: string) => void
}) => {
  const [isEditing, setIsEditing] = useState(false)
  const [tempValue, setTempValue] = useState('')

  const handleEdit = () => {
    if (!disabled) {
      setTempValue(value)
      setIsEditing(true)
    }
  }

  const handleCancel = () => {
    setTempValue(value)
    setIsEditing(false)
  }

  const handleSave = () => {
    onChange(tempValue)
    setIsEditing(false)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTempValue(e.target.value)
  }

  return (
    <Flex direction="row" alignItems="center" gap={1}>
      {!isEditing ? (
        <>
          <Header
            variant="h1"
            css={{
              color: value ? '$gray12' : '$gray6',
              cursor: 'pointer',
              padding: '2px 0',
            }}
            onClick={handleEdit}
          >
            {value || placeholder}
          </Header>
          {!disabled && (
            <IconButton
              title="Edit"
              onClick={handleEdit}
              icon={<Icon color="gray6" icon={faPenToSquare} />}
            />
          )}
        </>
      ) : (
        <>
          <InlineInput
            label=""
            type="text"
            value={tempValue}
            onChange={handleChange}
            placeholder={placeholder}
          />
          <IconButton
            title="Cancel"
            onClick={handleCancel}
            icon={<Icon color="gray6" icon={faXmark} />}
          />
          <IconButton
            title="Save"
            onClick={handleSave}
            icon={<Icon color="gray6" icon={faCheck} />}
          />
        </>
      )}
    </Flex>
  )
}

export default HeaderInlineInput
